//== pure logic for the early-redemption short-circuit
//== separate from calculate.js: depends on dates and product/buildComplete, not money inputs

import { PRODUCTS } from './calculate.js'

const DEFAULT_NB_THP_WINDOW = 6
const DEFAULT_SB_WINDOW = 24

//== whole calendar months elapsed from `from` to `to`
//== examples: 2026-01-15 → 2026-07-14 = 5; 2026-01-15 → 2026-07-15 = 6
//== returns null if either argument is not a valid Date
export function monthsBetween(from, to) {
  if (!(from instanceof Date) || !(to instanceof Date)) return null
  if (Number.isNaN(from.getTime()) || Number.isNaN(to.getTime())) return null

  let months = (to.getFullYear() - from.getFullYear()) * 12
  months += to.getMonth() - from.getMonth()
  if (to.getDate() < from.getDate()) months -= 1
  return months
}

//== returns true when the calculator should short-circuit the valuation/redemption steps
//== NB / THP: drawdown within `scheme.earlyWindowNbThpMonths` of `now`
//== self-build: drawdown within `scheme.earlyWindowSbMonths` AND buildComplete === false
export function isEarlyRedemption({ product, drawdownDate, buildComplete, scheme, now } = {}) {
  if (!product || !drawdownDate || !scheme) return false

  const drawdown = drawdownDate instanceof Date ? drawdownDate : new Date(drawdownDate)
  if (Number.isNaN(drawdown.getTime())) return false

  const reference = now instanceof Date ? now : new Date()
  const months = monthsBetween(drawdown, reference)
  if (months == null || months < 0) return false

  if (product === PRODUCTS.NEW_BUILD || product === PRODUCTS.THP) {
    return months < (scheme.earlyWindowNbThpMonths ?? DEFAULT_NB_THP_WINDOW)
  }
  if (product === PRODUCTS.SELF_BUILD) {
    if (buildComplete !== false) return false
    return months < (scheme.earlyWindowSbMonths ?? DEFAULT_SB_WINDOW)
  }
  return false
}
